var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"social",attrs:{"xs12":""}},[_c('ul',{staticClass:"juicer-feed",attrs:{"data-feed-id":"ypoglobal-f2ca3458-a19f-4559-994f-2f9c4a65d30e","data-columns":"3","data-truncate":"150","data-interval":"1000"}})])}
var staticRenderFns = []

export { render, staticRenderFns }